import clsx from 'clsx';
import type { FC } from 'react';

import type { Status } from './index';
import { tag } from './style.css';

type TagProps = {
  status: Status;
  minimum: string;
  maximum: string;
};

// SEC-001.1.1: NIST Policy - Only show length errors, no strength indicators
export const Tag: FC<TagProps> = ({ status, minimum, maximum }) => {
  const textMap: { [K in Status]: string } = {
    minimum,
    maximum,
  };

  return (
    <div
      className={clsx(tag, {
        minimum: status === 'minimum',
        maximum: status === 'maximum',
      })}
    >
      {textMap[status]}
    </div>
  );
};
